'use strict';exports.__esModule = true;var reducingToNumber = function reducingToNumber(value) {
  var parsedValue = Number.parseInt(value, 10);
  var result = 0;

  if (!Number.isNaN(parsedValue)) {
    result = parsedValue;
  } else if (value === 'double') {
    result = 2;
  }

  return result;
};exports.default =

function (parking) {
  if (!parking) {
    return 0;
  }
  return reducingToNumber(parking.aboveground) + reducingToNumber(parking.underground);
};module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/parkingConverter.js
// module id = 70
// module chunks = 0